
    /**
     * @description
     *  Modelo de un tipo de producto.
     *
     * @see gigot-backend/Models/Products/ProductType.cs
     */

export class ProductType {

	public code: string;
	public computable: boolean;
	public description: string;
	public id: number;

    /**
     * @description
     *	Construye un tipo de producto con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un tipo con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un tipo de producto vacío.
     */
    public static empty(): ProductType {
        const productType: ProductType = new ProductType();
		productType.code = "";
		productType.computable = false;
		productType.description = "";
		productType.id = undefined;
		return productType;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicProductType
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicProductType: ProductType): ProductType {
		if (!anemicProductType) return undefined;
        const productType: ProductType = ProductType.empty();
		productType.code = anemicProductType.code;
		productType.computable = anemicProductType.computable;
		productType.description = anemicProductType.description;
		productType.id = anemicProductType.id;
		return productType;
	}
}
